import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function FloatingActions() {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomepage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleInquiry = () => {
    if (isHomepage) {
      const el = document.getElementById('contact');
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollTo: 'contact' } });
    }
  };

  return (
    <>
      <button
        onClick={handleInquiry}
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-5 py-3 bg-primary-500 text-white text-sm font-heading font-semibold rounded-full shadow-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
        aria-label="Send inquiry"
      >
        <i className="ri-message-2-line"></i>
        <span className="hidden sm:inline">Inquiry</span>
      </button>

      <button
        onClick={scrollToTop}
        className={`fixed bottom-6 left-6 z-50 w-10 h-10 bg-white border border-[#E6EAF0] rounded-full flex items-center justify-center shadow-lg hover:bg-background-100 transition-all duration-300 ${
          showBackToTop ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="Back to top"
      >
        <i className="ri-arrow-up-line text-foreground-600"></i>
      </button>
    </>
  );
}